import React from 'react';
import Button from './Button';
import style from './index.scss';

export default ({ sliderView = false, className = '' }) => (
    <div className={`${style.card} ${sliderView ? style.sliderView : ''} ${className}`.trim()}>
        <div className={style.cardBody}>
            <div className={style.cardName} />
            <div className={style.cardTxtContainer}>
                <div className={style.cardTxt} />
                <div className={style.cardTxt} />
                <div className={style.cardTxt} />
            </div>
            <div className={style.cardBtnContainer}>
                <Button />
                <Button />
            </div>
        </div>
    </div>
);
